export default __webpack_public_path__ + "1e8856cd9f61b08a23486aae1c25eb56.png";